import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 18h-7a3 3 0 0 1 -3 -3v-10","key":"svg-0"}]]

/**
 * IconCurrencyLeu
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktbGV1Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNyAxOGgtN2EzIDMgMCAwIDEgLTMgLTN2LTEwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/currency-leu
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyLeu = createReactComponent('outline', 'currency-leu', 'CurrencyLeu', __iconNode);

export default IconCurrencyLeu;